import React from 'react';
import './Home.css';

const Home = () => {
    return (
        <section id="home" className="section">
            <div className="home-container">
                <div className="home-content">
                    <p className="home-subtitle">
                        Engineering ideas<br />
                        into intelligent<br />
                        experiences
                    </p>
                </div>
            </div>
            <div className="scroll-indicator">
                <span className="scroll-text">Scroll</span>
                <div className="scroll-arrow">→</div>
            </div>
        </section>
    );
};

export default Home;
